import type {InterfaceStrings} from './strings'

export const sv: InterfaceStrings = {
    nav: {
        beginSession: 'Börja',
        faq: 'Frågor',
        pricing: 'Priser',
        legal: 'Juridisk information',
        signIn: 'Logga in',
        viewPricing: 'Se priser',
        signOut: 'Logga ut',
        account: 'Konto',
        menu: 'Meny',
        closeMenu: 'Stäng menyn',
        mainNav: 'Huvudnavigering',
        sessions: {one: '{n} session', other: '{n} sessioner'},
    },
    footer: {
        selfHypnosisFor: 'Självhypnos vid',
        anxiety: 'Ångest',
        sleep: 'Sömnproblem',
        stress: 'Stress',
        confidence: 'Osäkerhet',
        focus: 'Koncentrationssvårigheter',
        learn: 'Bakgrund',
        ericksonian: 'Vad är Ericksonsk hypnos',
        aiHow: 'Så fungerar AI-hypnos',
        vsMeditation: 'Hypnos eller meditation',
        methods: 'Metoder',
        languages: 'Språk',
    },
    page: {
        cta: 'Börja din gratis session',
        hint: 'Din första session är gratis',
        exploreFurther: 'Läs vidare',
        disclaimer:
            'Quies är ett verktyg för avslappning och självutforskande. Det är ingen medicinteknisk produkt och ställer inga diagnoser, behandlar inte och botar inte något tillstånd. Om du befinner dig i en psykisk kris, kontakta vården.',
        transcript: 'Transkription',
        transcriptNote: 'Ett utdrag ur en riktig Quies-session, så som den lästes upp.',
        breadcrumb: 'Brödsmulor',
    },
    pricing: {
        selectPlan: 'Välj paketet',
        subscribe: 'Prenumerera',
        perMonth: 'per månad',
        manageSubscription: 'Hantera prenumeration',
        replayFree: 'Att lyssna på en tidigare session igen är alltid gratis.',
        offerLead: 'Varje session börjar där den förra slutade.',
    },
    session: {
        chooseLanguage: 'Välj ditt språk',
        changeLanguage: 'Byt språk',
        changeVoice: 'Byt röst',
        previewVoice: 'Lyssna på {voice}',
        stopPreview: 'Stoppa provet',
        continue: 'Fortsätt',
        composing: 'Quies skriver din session',
        preparing: 'Din meditation förbereds',
        pickingUp: 'vi fortsätter där du slutade',
        today: 'I dag',
        yesterday: 'I går',
        loading: 'Laddar…',
        showEarlier: 'Visa tidigare ({count})',
        tryDifferentApproach: 'Pröva en annan väg',
        nothingAdded: 'Inget tillagt',
        purchaseConfirmed: 'Köpet är bekräftat',
        firstSessionNote: 'Din första session är gratis. Du loggar in innan du lyssnar.',
    },
    threshold: {
        title: 'Logga in för att lyssna',
        message: 'Din första session är gratis. Inget kort behövs.',
        google: 'Fortsätt med Google',
        sendLink: 'Skicka en inloggningslänk till mig',
        sending: 'Skickar…',
        emailLabel: 'E-postadress',
        or: 'eller',
        waitingTitle: 'Kolla din e-post',
        waitingBody: 'Vi har skickat en inloggningslänk till {email}.',
        sendAgain: 'Skicka igen',
        googleInstead: 'Logga in med Google i stället',
        codeLabel: 'Eller skriv in den sexsiffriga koden från mejlet',
        codeSubmit: 'Fortsätt',
        codeSubmitting: 'Kontrollerar…',
        codeWrong: 'Koden stämmer inte.',
        codeDead: 'Koden fungerar inte längre. Använd länken i mejlet eller skicka ett nytt.',
        errors: {
            invalidEmail: 'Ange en giltig e-postadress.',
            rateLimited: 'För många försök. Försök igen om några minuter.',
            sessionError: 'Något gick fel med din inloggning. Uppdatera sidan och försök igen.',
            sendFailed: 'E-postmeddelandet kunde inte skickas. Försök igen.',
            sessionExpired: 'Din inloggning har gått ut. Uppdatera sidan och försök igen.',
            generic: 'Något gick fel. Försök igen.',
        },
    },
    player: {
        play: 'Spela',
        pause: 'Pausa',
        playAgain: 'Spela igen',
        seek: 'Position',
        eyesClosed: 'Slutna ögon',
        openEyes: 'Öppna ögonen',
        paused: 'Pausad',
        unavailable: 'Ljudet är inte tillgängligt',
        untitled: 'Quies-session',
    },
    failure: {
        turnFailed: 'Något gick fel hos oss. Ditt svar finns kvar.',
        reconnecting: 'Återansluter…',
        refusalTitle: 'Låt oss ta en annan väg',
        refusal: 'En del av ditt meddelande gick inte att svara på. Formulera om det, eller skicka det igen.',
        openElsewhere: 'Den här sessionen är också öppen i ett annat fönster.',
        serviceDown: 'Det går inte att nå Quies just nu. Inget av det du har gjort har gått förlorat.',
        sessionsUsedTitle: 'Dina sessioner är använda',
        voiceFailedTitle: 'Din meditation är skriven',
        voiceFailed: 'Rösten till den kunde inte skapas just nu. Inget går förlorat, och att läsa in den igen kostar ingenting.',
        voiceStopped: 'Rösten tystnade halvvägs. Den kan fortsätta där den slutade.',
        streamMissing: 'Din meditation är klar, men den har inte kommit fram till den här sidan.',
        tapToListen: 'Tryck för att lyssna',
        fileFailed: 'Den här inspelningen går inte att spela upp. Meditationen kan läsas in igen, utan kostnad.',
        recordingGone: 'Den här inspelningen sparas inte längre.',
        purchaseCancelled: 'Köpet avbröts. Ingenting har dragits.',
        purchasePending: 'Din betalning är bekräftad. Dina sessioner tar längre tid än vanligt att komma fram.',
        checkoutFailed: 'Betalningen kunde inte slutföras. Ingenting har dragits.',
        sessionEnded: 'Den här sessionen har nått sitt slut.',
        busy: 'Quies är mycket efterfrågat just nu. Ditt svar finns kvar; försök igen om en minut.',
        tooLong: 'Den här sessionen har blivit längre än Quies kan rymma. Du har fått tillbaka den.',
        notSaved: 'Det här steget kunde inte sparas. Försök igen för att fortsätta där du är.',
        meditationRefused:
            'Den här meditationen kunde inte skrivas så som du bad om. Formulera om dig, eller börja om: du får tillbaka den här sessionen.',
        meditationRefusedUncharged:
            'Den här meditationen kunde inte skrivas så som du bad om. Formulera om dig, eller börja om.',
        linkExpired: 'Din inloggningslänk har gått ut. Begär en ny.',
        oauthFailed: 'Inloggningen avbröts. Försök igen.',
        offline: 'Du är offline. Ditt svar skickas så snart du är tillbaka.',
        voiceChanged: 'Din röst finns inte längre; en annan röst läser den här meditationen.',
        voiceReturned: 'Rösten kunde fortfarande inte skapas. Du har fått tillbaka den här sessionen.',
        voiceFailedAgain: 'Rösten kunde fortfarande inte skapas.',
        voiceResuming: 'Rösten återupptas…',
        voiceLimited: 'Flera meditationer har redan lästs in åt dig den här timmen. Försök igen lite senare.',
        tryAgain: 'Försök igen',
        rephrase: 'Formulera om',
        resume: 'Återuppta',
        voiceAgain: 'Läs in igen',
        listen: 'Lyssna',
        continue: 'Fortsätt',
        begin: 'Börja en session',
        signIn: 'Logga in',
        checkAgain: 'Kontrollera igen',
        sendLink: 'Skicka inloggningslänk',
        useEmail: 'Använd e-post i stället',
    },
}
